import {LineCapStyle} from '@PosterWhiteboard/items/line-item/line-item.types';
import type {
  LineCapStyleOption,
} from '@Components/poster-editor/components/poster-editing-side-panel/components/line-cap-style-option/line-cap-style-option.types';

export const getOptionsArray = (): LineCapStyleOption[] => {
  return [
    {
      id: LineCapStyle.NONE,
    },
    {
      id: LineCapStyle.ARROW,
    },
    {
      id: LineCapStyle.CIRCLE,
    },
    {
      id: LineCapStyle.SQUARE,
    },
    {
      id: LineCapStyle.DIAMOND,
    },
    {
      id: LineCapStyle.T_BAR,
    },
    {
      id: LineCapStyle.FILLED_ARROW,
    },
    {
      id: LineCapStyle.FILLED_CIRCLE,
    },
    {
      id: LineCapStyle.FILLED_SQUARE,
    },
    {
      id: LineCapStyle.FILLED_DIAMOND,
    },
  ];
};